/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svcat_AiInputs */

const en_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const ar_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذكاء اصطناعي`)
};

const bn_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const de_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const es_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const fr_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const pt_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const zh_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const tr_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const ru_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const pl_svcat_ai = /** @type {(inputs: Svcat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

/**
* | output |
* | --- |
* | "AI" |
*
* @param {Svcat_AiInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svcat_ai = /** @type {((inputs?: Svcat_AiInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svcat_AiInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svcat_ai(inputs)
	if (locale === "bn") return bn_svcat_ai(inputs)
	if (locale === "de") return de_svcat_ai(inputs)
	if (locale === "es") return es_svcat_ai(inputs)
	if (locale === "fr") return fr_svcat_ai(inputs)
	if (locale === "pt") return pt_svcat_ai(inputs)
	if (locale === "zh") return zh_svcat_ai(inputs)
	if (locale === "tr") return tr_svcat_ai(inputs)
	if (locale === "ru") return ru_svcat_ai(inputs)
	if (locale === "pl") return pl_svcat_ai(inputs)
	return en_svcat_ai(inputs)
});